// src/api/index.js
import axios from 'axios';

const api = axios.create({
    baseURL: 'https://tpdv.points.beer', // La URL base de tu backend
});

// Interceptor: se ejecuta ANTES de cada petición
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            // Si hay un token, lo añade al header de autorización
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;